
    import '/home/ec2-user/Youlify-Design/components/watermark/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["watermark-demo-basic","watermark-demo-multi-line","watermark-demo-image","watermark-demo-custom","watermark-demo-portal"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/watermark/index.en-US.md?type=demo')
};